import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const SectionTitle = styled.p`
  ${typography.baseline.regularSans}
  margin-top: 0;
`

export const SelectContainer = styled(FormControl)({
  width: '100%',
})
export const StyledInputLabel = styled(InputLabel)`
  ${typography.baseline.regularSans}
`

export const StyledSelect = styled(Select)`
  ${typography.baseline.regularSans}
  background-color: ${colors.background.secondaryBackground};
  padding: 12px 0;
`

export const MenuItemWithPadding = styled(MenuItem)`
  ${typography.baseline.regularSans}
  padding: 12px 14px;
`
